import axios from 'axios';

const SingleIndicatorTrendPreviewAPI = (data) => axios.get(
	`${process.env.REACT_APP_STOCK_DOMAIN}/data_fetch/api/EconomicIndicatorData/${data.category},${data.value}`
);


export default { SingleIndicatorTrendPreviewAPI };
